// extracted by mini-css-extract-plugin
export default {"backgroundImg":"j8GfVepanscUHhPyrufD"};